import { render, staticRenderFns } from "./PropertyListing.vue?vue&type=template&id=52806bc9&scoped=true"
import script from "./PropertyListing.vue?vue&type=script&lang=js"
export * from "./PropertyListing.vue?vue&type=script&lang=js"
import style0 from "./PropertyListing.vue?vue&type=style&index=0&id=52806bc9&prod&lang=css"
import style1 from "./PropertyListing.vue?vue&type=style&index=1&id=52806bc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52806bc9",
  null
  
)

export default component.exports